import type { Subject } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { fromActions } from '@rxsv/core';

import { AppAction } from 'portlet/store/actions';
import type {
    DataTipNavigationOptionsRequestProps,
    DataTipNavigationOption,
    NavigationCallbackItem,
} from 'portlet/models';

export class TriggersAndActionsCommunicationInterface {
    constructor(private readonly action$: Subject<AppAction>) {}

    public requestDatatipContent(detail: DataTipNavigationOptionsRequestProps): Promise<{
        title: string;
        jumpTo: DataTipNavigationOption[];
        showBy: DataTipNavigationOption[];
    }> {
        if (!detail.position) return Promise.reject(new Error('Missing detail chart position'));

        this.action$.next(
            AppAction.triggersAndActions.TA_REQUEST_NAVIGATION_OPTIONS_FOR_DATATIP({
                position: detail.position,
                data: detail.data,
                filter: detail.filter,
                filters: detail.filters,
            }),
        );

        return firstValueFrom(
            this.action$.pipe(
                fromActions(AppAction.triggersAndActions.TA_RECEIVE_NAVIGATION_OPTIONS_FOR_DATATIP),
                map(({ payload }) => payload),
            ),
        );
    }

    public onDataTipNavigationItemClick(action: NavigationCallbackItem): void {
        this.action$.next(AppAction.triggersAndActions.TA_NAVIGATION_DATATIP_CLICK({ action }));
    }
}
